export default __webpack_public_path__ + "static/media/OnePage.4db44337.pdf";